import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from 'shared/config/config';

export type PasswordRulesType = {
	isValidLength: boolean;
	hasNonSpaceCharacter: boolean;
};

type PasswordRule = {
	key: keyof PasswordRulesType;
	validate: (password: string, length: number) => boolean;
};

const countCodePoints = (value: string) => Array.from(value).length;

export const normalizePassword = (password: string) => password.normalize('NFKC');

export const getDefaultPasswordRules = (): PasswordRulesType => ({
	isValidLength: false,
	hasNonSpaceCharacter: false,
});

const passwordRules: PasswordRule[] = [
	{
		key: 'isValidLength',
		validate: (_password, length) => length >= PASSWORD_MIN_LENGTH && length <= PASSWORD_MAX_LENGTH,
	},
	{
		key: 'hasNonSpaceCharacter',
		validate: (password) => Boolean(password.trim()),
	},
];

export const getPasswordRules = (password?: string): PasswordRulesType => {
	if (!password) {
		return getDefaultPasswordRules();
	}

	const normalizedPassword = normalizePassword(password);
	const passwordLength = countCodePoints(normalizedPassword);

	return passwordRules.reduce(
		(rules, rule) => ({
			...rules,
			[rule.key]: rule.validate(normalizedPassword, passwordLength),
		}),
		getDefaultPasswordRules()
	);
};

export const validPassword = (password: string) => {
	const rules = getPasswordRules(password);

	return Object.values(rules).every(Boolean);
};

export const getPasswordPolicyTranslationValues = () => ({
	minLength: PASSWORD_MIN_LENGTH,
	maxLength: PASSWORD_MAX_LENGTH,
});
